import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  private static nextId = 0;

  toggle_status: boolean = false
  @Input('labelAfter') labelAfter: boolean = false;
  @Input('label') label: string;
  @Input('disabled') disabled: boolean = false;
  /**
   * @description
   * id shared by the checkbox and its label. The default must be unique per instance:
   * it used to be Date.now(), so two switches created in the same millisecond (e.g. API Access
   * and Mobile Inquiry on one grid row) got the same id and a click on one label toggled the other.
  */
  @Input('for') for: number | string = `app-switch-${SwitchComponent.nextId++}`;

  @Input('checked') set checked(value: boolean) {
    this.toggle_status = value;
  }

  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void { }

  onChange() {
    this.onToggle.emit(this.toggle_status);
  }
}
